import type {
  AlignmentValue,
  PositionValue
} from '@elfsight/configurator-contracts';
import type { AlignmentPane, PopupLayout } from '../types';

const getAcrossAlignment = (alignment: AlignmentValue): PositionValue => {
  if (alignment === 'left') {
    return 'top-left';
  }

  if (alignment === 'right') {
    return 'top-right';
  }

  return 'top';
};

export function getContentPosition(
  layout: PopupLayout,
  elementsAlignment: AlignmentValue,
  elementsAlignmentPane: AlignmentPane
) {
  switch (layout) {
    case 'modal':
    case 'leftSlideIn':
    case 'rightSlideIn':
      return {
        position: getAcrossAlignment(elementsAlignment)
      };
    case 'leftPane':
    case 'rightPane':
      return {
        position: elementsAlignmentPane.position
      };
    case 'topBar':
    case 'bottomBar':
      return { position: 'center' as const };
    default:
      return undefined;
  }
}
